import React, {useState, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import * as R from 'ramda';
import {Card, CardBody, Row, Col, Button} from 'reactstrap';

import Form from '@/Form';
import Text from '@/Form/Text';
import {blank} from '@/util';
import Icon from '@/views/shared/Icon';
import api from '@/api';

import Separator from '@/views/shared/Separator';
import SuccessWithEmail from '@/views/ForgetPassword/SuccessWithEmail';
import SuccessWithoutEmail from '@/views/ForgetPassword/SuccessWithoutEmail';
import Tooltip from '@/views/shared/Tooltip';
import styles from '@/views/ForgetPassword/index.module.css';

const metaFields = ['errors'];

const ForgetPassword = () => {
  const [formData, setFormData] = useState({});
  const [flashData, setFlashData] = useState({});
  const {t: tr} = useTranslation('forget_password');

  useEffect(() => {
    const data = {
      idNo: '',
      birthDay: '',
      birthMonth: '',
      birthYear: '',
    };

    setFormData(data);
  }, {});

  const handleSubmit = event => {
    event.preventDefault();
    api
      .post('/forget_password', R.omit(metaFields, formData))
      .then(({data}) => {
        const errors = R.propOr({}, 'errors')(data);
        if (blank(errors)) {
          setFlashData(data.success);
        }
        setFormData(R.assoc('errors', errors));
      });
  };

  if (blank(formData)) {
    return null;
  }

  if (!blank(flashData)) {
    if (R.prop('withEmail')(flashData)) {
      return <SuccessWithEmail email={R.prop('email')(flashData)} />;
    }
    return <SuccessWithoutEmail />;
  }

  return (
    <Form stateHook={[formData, setFormData]} onSubmit={handleSubmit}>
      <Card>
        <CardBody className={styles.section}>
          <div className='text-center'>
            <h1 className={styles.title}>{tr('title')}</h1>
            <Separator />
            <h3 className={styles.subtitle}>{tr('sub_title')}</h3>
          </div>
          <Row>
            <Col md={{size: 5, offset: 3}}>
              <h5>{tr('form_head_title')}</h5>
            </Col>
          </Row>
          <Row>
            <Col md={{size: 4, offset: 3}}>
              <div style={{fontSize: '18px'}}>
                {tr('identification_number')}
                <Icon
                  icon='question'
                  id='question_icon'
                  style={{margin: '0 10px 0 20px', color: 'red'}}
                />
                <Tooltip
                  target='question_icon'
                  text={tr('identification_number_tooptip_text')}
                />
              </div>
            </Col>
          </Row>
          <Row form>
            <Col md={{size: 6, offset: 3}}>
              <Text
                name='idNo'
                placeholder={`${tr('identification_number_placeholder')}`}
                required
              />
            </Col>
          </Row>
          <Row>
            <Col md={{size: 4, offset: 3}}>
              <div style={{fontSize: '18px'}}>{tr('date_of_birth')}</div>
            </Col>
          </Row>
          <Row form>
            <Col md={{size: 2, offset: 3}}>
              <Text name='birthDay' placeholder={tr('dd')} required />
            </Col>
            <Col md={2}>
              <Text name='birthMonth' placeholder={tr('mm')} required />
            </Col>
            <Col md={2}>
              <Text name='birthYear' placeholder={tr('yyyy')} required />
            </Col>
          </Row>
          <Row>
            <Col md={{size: 6, offset: 3}} className='text-center'>
              <Button size='lg' type='submit' value='Y' color='secondary' block>
                {tr('submit')}
              </Button>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Form>
  );
};

export default ForgetPassword;
